import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { OpportunityCompetitorEntity } from './opportunity-competitor.entity';

/**
 * PD-17327 — one line of a competitor's bid on an opportunity: what (an item
 * when it is one of ours, else the description), how many and at what unit
 * price. A line with an item also records the price as that competitor's
 * competitive price for the customer and item (`fk_competitive_price__id`
 * points at it, so editing the bid updates the same price).
 *
 * SM1 exposure: none (a new table).
 */
@Index('opportunity_competitor_line__fk_opportunity_competitor__id', ['fkOpportunityCompetitorId'], {})
@Entity('opportunity_competitor_line')
export class OpportunityCompetitorLineEntity extends BaseEntity {
	@Column('int', { name: 'fk_opportunity_competitor__id', unsigned: true })
	public fkOpportunityCompetitorId!: number;

	@Column('int', { name: 'lineNumber', unsigned: true })
	public lineNumber!: number;

	@Column('int', { name: 'fk_item__id', unsigned: true, nullable: true })
	public fkItemId!: number | null;

	@Column('varchar', { name: 'itemExternalId', length: 64, nullable: true })
	public itemExternalId!: string | null;

	@Column('varchar', { name: 'description', length: 255, nullable: true })
	public description!: string | null;

	@Column('decimal', { name: 'quantity', precision: 15, scale: 4, nullable: true })
	public quantity!: string | null;

	@Column('decimal', { name: 'unitPrice', precision: 15, scale: 6, nullable: true })
	public unitPrice!: string | null;

	@Column('int', { name: 'fk_competitive_price__id', unsigned: true, nullable: true })
	public fkCompetitivePriceId!: number | null;

	@ManyToOne(() => OpportunityCompetitorEntity, { onDelete: 'CASCADE', onUpdate: 'RESTRICT' })
	@JoinColumn([{ name: 'fk_opportunity_competitor__id', referencedColumnName: 'id' }])
	public bid!: OpportunityCompetitorEntity;
}
